import React from 'react';

import { Text, List, ListProps, ListItem } from '@opendoor/bricks/core';
import { useTheme } from '@opendoor/bricks/system/theme';

export interface CheckListItem {
  title?: string;
  body?: string;
}
interface CheckListProps extends Omit<ListProps, 'variant' | 'children'> {
  list: Array<CheckListItem>;
}

// component-test-check-ignore
/** TODO: Add documentation */
export const CheckList: React.FC<CheckListProps> = ({ list, ...props }) => (
  <List variant="checklist" my={7} spacing={5} {...props}>
    {list.map(({ title, body }, index) => (
      <ListItem key={`${title}-${index}`} pl={4}>
        {title && (
          <Text fontSize="s0" fontWeight="bold" lineHeight={1.75}>
            {title}
          </Text>
        )}
        {body && (
          <Text fontSize="s0" lineHeight={1.75}>
            {body}
          </Text>
        )}
      </ListItem>
    ))}
  </List>
);

/** Checkmark shown in the VA Checklist and ScheduleSection */
export const CheckmarkIcon: React.FC = () => {
  const { colors } = useTheme();
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden>
      <rect
        x="0.117188"
        y="0.894775"
        width="14"
        height="14"
        rx="7"
        fill={colors.brand50 as string}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.539 7.31746C10.9513 6.95161 10.9971 6.31133 10.6414 5.88734C10.2857 5.46335 9.6632 5.41623 9.25099 5.78207L5.9192 8.73916L5.0277 7.69385C4.66867 7.27286 4.04581 7.23096 3.63652 7.60025C3.22722 7.96955 3.18649 8.6102 3.54552 9.03118L4.9627 10.6929C4.99182 10.7432 5.02559 10.7916 5.06406 10.8374C5.41975 11.2614 6.04225 11.3085 6.45445 10.9427L10.539 7.31746Z"
        fill={colors.neutrals0 as string}
      />
    </svg>
  );
};
